import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  sideBarRequired = true;

  constructor(private location: Location,
              private router: Router) {
  }

  ngOnInit() {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      this.sideBarRequired =  this.location.path().indexOf('login') < 0;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/sidebar/sidebar.component.ts